import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 20 19",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 19\" id=\"icon-account\"><path d=\"M10 11c5.52 0 10 2.093 10 4.667V19H0v-3.333C0 13.093 4.48 11 10 11Zm8.667 4.667c0-1.84-3.88-3.334-8.667-3.334s-8.667 1.494-8.667 3.334v2h17.334v-2ZM10 0a4.666 4.666 0 1 1 0 9.333A4.666 4.666 0 0 1 10 0Zm0 1.333A3.333 3.333 0 1 0 10 8a3.333 3.333 0 0 0 0-6.667Z\" fill=\"#003C71\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol